module.exports = __webpack_public_path__ + "img/financial.592f72bd.svg";